import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hotspot/step_icon.png'
import _imports_1 from '@/assets/hotspot/tips_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-df7cc1a4")

_pushScopeId("data-v-df7cc1a4")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = {
  key: 0,
  class: "cover-wrapper"
}
const _hoisted_3 = { class: "top-wrapper" }
const _hoisted_4 = { class: "top-content" }
const _hoisted_5 = { class: "content-wrapper" }
const _hoisted_6 = { class: "right-container" }
const _hoisted_7 = { class: "right-top" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "right-action" }, [
  /*#__PURE__*/_createVNode("span", null, "查看")
], -1)
const _hoisted_9 = { class: "left-container" }
const _hoisted_10 = {
  key: 1,
  class: "detail-wrapper-bg"
}
const _hoisted_11 = { class: "detail-wrapper" }
const _hoisted_12 = { class: "detail-top" }
const _hoisted_13 = { class: "detail-top-image" }
const _hoisted_14 = { class: "detail-top-intro" }
const _hoisted_15 = { class: "detail-prepare" }
const _hoisted_16 = { class: "detail-prepare-title" }
const _hoisted_17 = { class: "detail-step" }
const _hoisted_18 = { class: "detail-step-title" }
const _hoisted_19 = { class: "detail-step-item-title" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_21 = { class: "detail-step-item-image" }
const _hoisted_22 = { class: "detail-step-item-intro" }
const _hoisted_23 = {
  key: 0,
  class: "detail-tips"
}
const _hoisted_24 = { class: "detail-tips-title" }
const _hoisted_25 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_26 = { class: "detail-tips-intro" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HotspotLogoTips = _resolveComponent("HotspotLogoTips")
  const _component_ImgContainer = _resolveComponent("ImgContainer")
  const _component_Back = _resolveComponent("Back")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", null, _toDisplayString(_ctx.modules.top.title), 1),
                _createVNode("div", _hoisted_4, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.top.intro, (i, k) => {
                    return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                  }), 128))
                ])
              ]),
              _createVNode("div", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list, (i, k) => {
                  return (_openBlock(), _createBlock("div", {
                    key: k,
                    class: "content-item",
                    onClick: _withModifiers(($event: any) => (_ctx.click(k)), ["stop","prevent"])
                  }, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("span", null, _toDisplayString(i.name), 1)
                      ]),
                      _hoisted_8
                    ]),
                    _createVNode("div", _hoisted_9, [
                      _createVNode("img", {
                        src: i.cover
                      }, null, 8, ["src"])
                    ])
                  ], 8, ["onClick"]))
                }), 128))
              ]),
              _createVNode(_component_HotspotLogoTips, {
                text: _ctx.modules.logoTips,
                onAction: _ctx.goZsPage
              }, null, 8, ["text", "onAction"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail && _ctx.modules.list[_ctx.currentIndex].detail)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_ImgContainer, {
                      src: _ctx.modules.list[_ctx.currentIndex].detail.top.img
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.top.intro, (i, k) => {
                      return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].detail.prepare.title), 1)
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.prepare.list, (i, k) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "detail-prepare-item",
                      key: k
                    }, [
                      _createVNode("span", null, _toDisplayString(i.name), 1),
                      _createVNode("span", null, _toDisplayString(i.count), 1)
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].detail.step.title), 1)
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.step.list, (i, k) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "detail-step-item",
                      key: k
                    }, [
                      _createVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode("span", null, _toDisplayString(i.title), 1)
                      ]),
                      _createVNode("div", _hoisted_21, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(i.imgs, (m, n) => {
                          return (_openBlock(), _createBlock(_component_ImgContainer, {
                            key: n,
                            src: m
                          }, null, 8, ["src"]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_22, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(i.intro, (m, n) => {
                          return (_openBlock(), _createBlock("p", { key: n }, _toDisplayString(m), 1))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                (_ctx.modules.list[_ctx.currentIndex].detail.tips)
                  ? (_openBlock(), _createBlock("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].detail.tips.title), 1)
                      ]),
                      _createVNode("div", _hoisted_26, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.tips.intro, (i, k) => {
                          return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock(_component_Back, {
              key: 2,
              onAction: _ctx.goBack
            }, null, 8, ["onAction"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})